import { Pipe } from '@angular/core';
var TrurthifyPipe = (function () {
    function TrurthifyPipe() {
    }
    TrurthifyPipe.prototype.transform = function (input) {
        return Array.isArray(input)
            ? input.filter(function (e) { return !!e; })
            : input;
    };
    TrurthifyPipe.decorators = [
        { type: Pipe, args: [{ name: 'truthify' },] },
    ];
    /** @nocollapse */
    TrurthifyPipe.ctorParameters = function () { return []; };
    return TrurthifyPipe;
}());
export { TrurthifyPipe };
//# sourceMappingURL=truthify.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/truthify.js
// module id = 235
// module chunks = 4